module.exports = __webpack_public_path__ + "static/media/frenchMate.ef50fafd.png";